import useAuthSuccessCallback from './useAuthSuccessCallback'
import { STATUS, UNAUTHORIZED_TYPES } from 'utils/constants'
import { selectRestPopupBody } from 'rest/restSlice'
import { newmailcode, newsmscode } from 'rest/urls'
import useTranslation from 'hooks/useTranslation'
import ResendCode from 'components/ResendCode'
import Submit from 'components/inputs/Submit'
import PinForm from 'components/PinForm'
import { useReduxSelector } from 'store'
import { POST } from 'rest/request'
import { useState } from 'react'

const OtpPopup: React.FC = () => {

  const popupBody = useReduxSelector(selectRestPopupBody)
  const { recipient, additional_recipient, type, verified } = popupBody as rest.UnauthorizedResponse

  const [sentTo, setSentTo] = useState(recipient)
  const [token, setToken] = useState('')
  const [warning, setWarning] = useState(false)
  const [status, setStatus] = useState<keyof typeof STATUS>(STATUS.idle)

  const { t } = useTranslation('auth')
  const successCallback = useAuthSuccessCallback()
  const submit = () => {
    successCallback({ success: true, token })
  }

  const getCode = async (additional = false) => {
    if (status === STATUS.pending) return
    setStatus(STATUS.pending)

    try {
      const body = { [type]: recipient, ...(additional && { additional: '1' }) }
      const response = await POST(type === UNAUTHORIZED_TYPES.mailOtp ? newmailcode : newsmscode, { body })
      if (response) {
        setStatus(STATUS.succeed)
        setSentTo(response?.recipient || (additional ? additional_recipient : recipient))
      } else throw new Error('Wrong response')

    } catch (error) {
      setStatus(STATUS.failed)
      console.error('Getting code failed, failed message: ', error)
      return false
    }
  }

  return (
    <div className='popup__verification'>
      <div className='popup__title'>
        <div>{t('authorization')}</div>
      </div>

      <div className='popup__form'>
        {verified === false && <p className='verification__warning'>{t('incorrectCode')}</p>}

        {recipient && <>
          <div className='verification__text'>
            <div>{t('rewriteTheVerificationCode')}</div>
            <div>{t('sentTo')}</div>
          </div>

          <h2>{sentTo}</h2>
        </>}

        <PinForm
          isCode
          autoFocus
          value={token}
          warning={warning}
          autoLoadCodeFromSMS
          setWarning={setWarning}
          setValue={setToken}
          submit={submit}
        />

        <ResendCode
          className='verification__phone'
          text={t('pleaseResend')}
          recipient={recipient}
          additionalRecipient={additional_recipient}
          send={getCode}
        />

        <Submit
          text={t('confirm')}
          action={() => token?.length === 6 ? submit() : setWarning(true)} />
      </div>
    </div>
  )
}

export default OtpPopup